export default {
  COMMON: {
    ACCOUNT: "Account",
    APPS: "Apps",
    BALANCE: "Balance",
    BLOCK: "Block",
    BLOCKS: "Blocks",
    CONFIRMATIONS: "Confirmations",
    DELEGATE: "Current Witness",
    DELEGATES: "Total Witness",
    EXPIRATION: "Expiration",
    FEE: "Fee",
    HEIGHT: "Height",
    ID: "ID",
    NO_RESULTS: "No results",
    NOT_APPLICABLE: "Not applicable",
    RANK: "Rank",
    RELOAD: "Reload this page",
    SEE_ALL: "See all",
    SUPPLY: "Supply",
    SBD_SUPPLY: "SBD Supply",
    SUPPLY_PERCENTAGE: "Percentage of the total supply",
    TIMESTAMP: "Timestamp",
    TRANSACTION: "Transaction",
    TRANSACTIONS: "Block Transactions",
    TYPE: "Type",
    WALLET: "Wallet",
    ACCEPT: "Accept",
    CANCEL: "Cancel",
    VALUE: "Account Value",
    DAILY_ACTIVE:"Daily Active Users",
    DAILY_TRANSACTIONS:"Daily Transactions",
    DAILY_VOLUME:"Daily USD Volume"
  },

  DISCLAIMER: {
    TITLE: "Disclaimer",
    TEXT1:
      "The following page is a directory for informational purposes only. {website} is in no way affiliated with the listed individuals and/or business and bridgechain entities listed herein. All links provided herein are third party websites that have not been verified and are owned by independent parties over which {website} has no control. {website} does not endorse or approve and makes no warranties, representations or undertakings relating to the content of third party websites.",
    TEXT2: "By clicking “Accept” you will be confirming that you have read and are in agreement with all terms herein.",
  },

  MSTEEMET_CHART: {
    ERROR: "The chart data could not be loaded",
    RELOAD: "Reload chart",
    PRICE: "Price",
    VOLUME: "Volume",
    DAY: "Day",
    WEEK: "Week",
    MONTH: "Month",
    QUARTER: "Quarter",
    YEAR: "Year",
    ALL_TIME: "All time",
  },

  BLOCK: {
    ID: "Block ID",
    NUMBER: "Block Number",
    PAGINATION: {
      NEXT: "Next block",
      PREVIOUS: "Previous block",
    },
    FEES: "Fees",
    MINED_BY: "Mined by",
    REWARD: "Reward",
    PROCESSED_AMOUNT: "Processed amount",
    TOTAL_FORGED: "Total forged",
  },

  TRANSACTION: {
    AMOUNT: "Amount/%/Payload",
    AMOUNT_TO_SEND: "Amount",
    CURRENCY: "Currency",
    AMOUNT_TO_SELF: "Excluding {amount} sent to itself",
    BLOCK_ID: "Block ID",
    SIGNATURES: "Signatures",
    TX_NUM: "Transaction Num",
    ID: "Transaction ID",
    MEMO: "Memo",
    IPFS: "IPFS Hash",
    FEE: "Fee",
    MULTI_SIGNATURE: {
      ADDRESS: "Generated address",
      MIN: "Minimum participants",
      LIFETIME: "Lifetime",
      PARTICIPANTS: "Participants",
      LEGACY_NOTICE: "This transaction is a legacy Multisignature Registration",
    },
    NONCE: "Nonce",
    TIMELOCK: {
      BLOCKHEIGHT: "Expiration blockheight",
      CLAIMED: "Claimed transaction",
      EXPIRATION: "Expiration",
      EXPIRED: "Expired lock",
      OPEN: "Open lock",
      REFUNDED: "Refunded transaction",
      SECRET_HASH: "Secret Hash",
      STATUS: "Timelock status",
      UNKNOWN: "Unknown",
      UNLOCK_SECRET_HEX: "Unlock Secret (hex)",
    },
    TYPE: "Type",
    TYPES: {
      ALL: "All",
      TRANSFER: "Transfer",
      COMMENT: "Comment",
      DELETE_COMMENT: "Delete Comment",
      ACCOUNT_UPDATE: "Account Update",
      ACCOUNT_UPDATE2: "Account Update2",
      ACCOUNT_CLAIM: "Account Claim",
      ACCOUNT_CREATE: "Account Create",
      CUSTOM_JSON: "Custom JSON",
      VOTE: "Vote",
      CLAIM_REWARD_BALANCE: "Claim reward",
      CURATION_REWARD: "Curation reward",
      DELEGATE_VESTING_SHARES: "Delegate",
      WITHDRAW_VESTING: "PowerDown",
      ACCOUNT_WITNESS_VOTE: "Witness Vote",
      TRANSFER_TO_SAVINGS: "Transfer to Savings",
      TRANSFER_TO_VESTING: "PowerUp",
      LIMIT_ORDER_CREATE: "Order Create",
      LIMIT_ORDER_CANCEL: "Order Cancel",
      DELEGATE_RESIGNATION: "Delegate Resignation",
      BUSINESS_REGISTRATION: "Business Registration",
      BUSINESS_RESIGNATION: "Business Resignation",
      BUSINESS_UPDATE: "Business Update",
      SENT: "Sent",
      RECEIVED: "Received",
      UNKNOWN: "Unknown",
    },
    ASSET: {
      BRIDGECHAINASSETREPOSITORY: "Bridgechain Asset Repository",
      BRIDGECHAINID: "Bridgechain ID",
      BRIDGECHAINREPOSITORY: "Bridgechain repository",
      GENESISHASH: "Genesis hash",
      NAME: "Name",
      PORTS: "Ports",
      REPOSITORY: "Repository",
      SEEDNODES: "Seed nodes",
      VAT: "VAT",
      WEBSITE: "Website",
    },
    SENDER: "Sender",
    RECIPIENT: "Receiver/Permlink/Id",
    RECIPIENTS: "Recipients",
    WELL_CONFIRMED: "Well confirmed",
  },

  WALLET: {
    ACCOUNT: "Account",
    USERNAME: "Username",
    ADDRESS: "Address",
    UPVOTE_VALUE: "Upvote Value",
    VOTING_POWER: "Voting Power",
    VESTING_SHARES: "Vesting Shares",
    EFFECTIVE_SP: "Effective SP",
    SP: "Account SP",
    VALUE: "Account Value",
    PUBLIC_KEY: "Public key",
    VERIFIED: "This is a verified address",
    VOTING_FOR: "Voting for",
    BALANCE: "Balance ({token})",
    SBD_BALANCE: "SBD Balance",
    LOCKED_BALANCE: "Locked Balance",
    SECOND_PASSPHRASE_ENABLED: "Second signature enabled",
    MULTI_SIGNATURE_WALLET: "Multisignature wallet",
    SUMMARY: "Account summary",
    QR_CODE: "QR Code",
    SCAN_FOR_ADDRESS: "Scan for address",
    SEND: "Send",
    DELEGATE: {
      FORGED_BLOCKS: "Forged blocks",
      TOTAL_FORGED: "Total forged",
      RANK: "Rank",
      RANK_NOT_AVAILABLE: "Not yet available",
      RANK_NOT_APPLICABLE: "Not applicable",
      STATUS: {
        TITLE: "Status",
        ACTIVE: "Active",
        STANDBY: "Standby",
        RESIGNED: "Resigned",
      },
      USERNAME: "Username",
      VOTES: "Votes",
      VOTERS: "Voters",
      VOTER_THRESHOLD: "Only voters with more than 0.1 {token}",
    },
    SCAN_FOR_URI: "Scan",
    ADVANCED_QR: {
      EXPAND: "Expand",
      COLLAPSE: "Collapse",
    },
    TIMELOCK_TRANSACTION: "Timelock transaction",
  },

  SEARCH: {
    PLACEHOLDER: {
      SHORT: "Search",
      LONG: "Find a block, transaction, account or witness",
    },
    NO_RESULTS: "Nothing matched your search",
  },

  BUTTON_CLIPBOARD: {
    SUCCESS: "Copied!",
    ERROR: "Error!",
    COPY_TO_CLIPBOARD: "Copy to clipboard",
  },

  PAGES: {
    DEV_TOOLS:{
      TITLE: "Dev Tools",
      SEED: "Seeds",
      RPC: "RPC's",
      NAME: "Name",
      URL: "URL",
      STATUS: "Status",
    },
    APPS: {
      TITLE: "DApps",
      TOP: "Top",
      ALL: "All",
      NAME: "Name",
      ABOUT: "About",
      WEBSITE: "Website",
      TYPE: "Type",
      CATEGORY: "Category",
      USERS: "Users",
      TRANSACTIONS: "Transactions",
      PUBLISHER: "Publisher"

    },
    HOME: {
      TITLE: "Home",
      HEADER: "Latest prices and volumes",
      LATEST_TRANSACTIONS: "Latest transactions",
      LATEST_BLOCKS: "Latest blocks",
    },
    DELEGATES: {
      TITLE: "Delegates",
    },
    CONVERT:{
      TITLE: "Quick Convert",
      AMOUNT: "Steem Amount",
      ADDRESS: "Withdrawal Address"
    },
    CREATOR: {
      TITLE: "Account Creation",
      USERNAME:"Steem Username"
    },
    WITNESSES: {
      TITLE: "Witnesses",
      HEADER: {
        LAST_BLOCK: "Last block height",
        FORGED: "Mined",
        TOTAL_FORGED: "Total mined ({token})",
        TX_COUNT: "from 0 transactions | from 1 transaction | from {count} transactions",
        TRANSACTIONS: "Transaction Count",
      },
      ACTIVE: "Active",
      APPROVAL: "Approval (MV)",
      STANDBY: "Standby",
      WITNESS: "Witness",
      RESIGNED: "Resigned",
      NEVER: "Never",
      FORGED_BLOCKS: "Mined blocks",
      LAST_FORGED: "Last mined",
      REG_FEE: "Reg Fee",
      MISSED_BLOCKS: "Missed",
      PRICE_FEED: "Price feed",
      STATS: {
        FORGED: "Mined block recently",
        IN_QUEUE: "In queue for mining",
        MISSED: "Missed round",
        NOT_FORGING: "Not mining",
      },
      STATUS: {
        TITLE: "Status",
        FORGING: "Forging",
        MISSING: "Missing",
        NOT_FORGING: "Not forging",
        NEVER_FORGED: "Never forged",
        BECAME_ACTIVE: "Became active",
      },
      VERSION: "Version",
      VOTE: "Vote",
      VOTES: "Votes",
      TOOLTIP: "Last block @ {height} on",
    },
    TOP_WALLETS: {
      TITLE: "Top Wallets",
    },
    TOP_HOLDERS: {
      TITLE: "Top Holders",
    },
    TOP_VOTERS: {
      TITLE: "Top Voters",
    },
    TOP_DOWNVOTERS: {
      TITLE: "Top Downvoters",
    },
    STEEM_DAPPS: {
      TITLE: "DApps",
    },
    SEARCH: {
      TITLE: "Search",
      ADDITIONAL_PARAMETERS: "Additional Parameters",
      RESULTS: "Results",
      SEARCH_TYPE: "Search Type",
      GENERIC: {
        DATE_FROM: "Date from",
        DATE_TO: "Date to",
      },
      BLOCK: {
        TOTAL_AMOUNT_FROM: "Total amount from",
        TOTAL_AMOUNT_TO: "Total amount to",
        TOTAL_FEE_FROM: "Total fee from",
        TOTAL_FEE_TO: "Total fee to",
        REWARD_FROM: "Reward from",
        REWARD_TO: "Reward to",
      },
      TRANSACTION: {
        AMOUNT_FROM: "Amount from",
        AMOUNT_TO: "Amount to",
        FEE_FROM: "Fee from",
        FEE_TO: "Fee to",
      },
      WALLET: {
        BALANCE_FROM: "Balance from",
        BALANCE_TO: "Balance to",
      },
    },
    NOT_FOUND: {
      TITLE: "Ooops!",
      PAGE: "Sorry, page not found",
      DATA: "Sorry, {dataType} {dataId} could not be found on the blockchain please try again in few seconds.",
    },
  },

  PAGINATION: {
    ALL: "All",
    NEXT: "Next",
    OF: "of",
    PAGE: "Page",
    PREVIOUS: "Previous",
    ROWS_PER_PAGE: "Rows per page",
    SHOW_MORE: "Show more",
    PLACEHOLDER: {
      SHORT: "Page #",
      LONG: "Enter a page number",
    },
    NO_RESULTS: "Invalid page number",
  },

  HEADER: {
    MENU: "Menu",
    NETWORK: "Network",
    MAIN: "Main",
    DEVELOPMENT: "Development",
    SUPPLY: "Supply",
    MARKET_CAP: "MSTEEMet Cap",
    TESTNET_LOCAL: "Testnet Local",
  },

  FOOTER: {
    ALL_RIGHTS_RESERVED: "All rights reserved",
    VERSION: "Version",
    DATE: "Date",
  },
};
